import TextFieldsIcon from "@mui/icons-material/TextFields";
import FunctionsIcon from "@mui/icons-material/Functions";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import DataObjectIcon from "@mui/icons-material/DataObject";
import { VariableType } from "../../../models/interactions/Variable";

interface VariableTypeSelectorProps {
  selectedType: VariableType;
  onSelect: (type: VariableType) => void;
}

export default function VariableTypeSelector({
  selectedType,
  onSelect,
}: VariableTypeSelectorProps) {
  const typeOptions = [
    {
      type: VariableType.String,
      label: "String",
      icon: <TextFieldsIcon sx={{ fontSize: 24 }} />,
    },
    {
      type: VariableType.Number,
      label: "Number",
      icon: <FunctionsIcon sx={{ fontSize: 24 }} />,
    },
    {
      type: VariableType.Boolean,
      label: "Boolean",
      icon: <ToggleOnIcon sx={{ fontSize: 24 }} />,
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-center text-creator-primary">
        <DataObjectIcon sx={{ fontSize: 24 }} />
      </div>
      <div className="grid grid-cols-2 gap-2">
      {typeOptions.map((option) => {
        const isSelected = selectedType === option.type;
        return (
          <button
            key={option.type}
            type="button"
            onClick={() => onSelect(option.type)}
            className={`
              flex flex-col items-center justify-center gap-1 p-2 rounded-[20px]
              border-2 transition-all cursor-pointer min-h-[70px] font-poppins
              ${
                isSelected
                  ? "border-creator-primary bg-creator-primary-washed"
                  : "bg-creator-surface border-creator-border hover:border-creator-primary/50"
              }
            `}
          >
            <div
              className={
                isSelected ? "text-creator-primary" : "text-creator-text-sub"
              }
            >
              {option.icon}
            </div>
            <span
              className={`text-[12px] font-medium font-poppins ${
                isSelected ? "text-creator-primary" : "text-creator-text-sub"
              }`}
            >
              {option.label}
            </span>
          </button>
        );
      })}
      </div>
    </div>
  );
}
